export const config = {
  title: "REMODELING JT | Remodelación de Casas | Romeoville, IL",
  meta: {
    description:
      "REMODELING JT - Expertos en remodelación de cocinas, baños y casas en Romeoville, IL. Transformando espacios, creando hogares. Diseños funcionales, materiales de alta calidad e instalación profesional garantizada.",
    keywords: [
      "REMODELING JT",
      "Remodelación de Casas",
      "Cocinas Modernas",
      "Remodelación de Baños",
      "Romeoville IL",
      "Jean F Teran",
      "Remodeling Contractor",
      "Kitchen Remodeling",
      "Bathroom Renovation",
      "Home Improvement"
    ],
    author: "REMODELING JT",
    canonicalUrl: "https://remodelingjtllc.com/",
  },
  sections: {
    header: {
      businessName: "REMODELING JT",
    },
    sectionB: {
      heroTitle: "Transforma tu hogar hoy mismo",
      heroSubtitle: "Expertos en remodelación de cocinas, baños y más para tu casa",
      learnAboutText: "Solicita tu Presupuesto",
      phoneNumber: "3124985712",
      phoneLabel: "+1 (312) 498-5712",
      heroBackgroundImage:
        "https://images.unsplash.com/photo-1556912172-45b7abe8b7e1?q=80&w=2070&auto=format&fit=crop",
      cardData: [
        {
          title: "Cocinas Modernas",
          description:
            "Diseños funcionales y elegantes con materiales de alta calidad e instalación profesional garantizada.",
        },
        {
          title: "Baños Renovados",
          description:
            "Espacios personalizados que transforman tu baño en un oasis de relajación con acabados de alta calidad.",
        },
        {
          title: "Salas Acogedoras",
          description:
            "Creamos espacios que combinan comodidad y estilo para tu bienestar diario.",
        },
      ],
      description:
        "En REMODELING JT, nos especializamos en la remodelación de casas, cocinas y más, ofreciendo soluciones personalizadas para cada cliente con un enfoque en la calidad y el detalle. Transformando espacios, creando hogares.",
    },
    sectionC: {
      servicesTitle: "Servicios de Remodelación",
      servicesDescription:
        "Ofrecemos soluciones personalizadas para transformar tu hogar en un espacio ideal. Más de 150 clientes satisfechos confían en nuestra calidad garantizada.",
      cards: [
        {
          title: "Cocinas Modernas",
          description:
            "Diseñamos cocinas funcionales y estéticas que se adaptan a tus necesidades y estilo, con materiales de alta calidad y diseño contemporáneo.",
          imageSrc: "https://images.unsplash.com/photo-1556911220-bff31c812dba?q=80&w=2068&auto=format&fit=crop",
          imageAlt: "Remodelación de Cocinas Modernas",
        },
        {
          title: "Baños Elegantes",
          description:
            "Transformamos baños en oasis de relajación con acabados de alta calidad, diseño contemporáneo y espacios personalizados.",
          imageSrc: "https://images.unsplash.com/photo-1552321554-5fefe8c9ef14?q=80&w=2187&auto=format&fit=crop",
          imageAlt: "Remodelación de Baños",
        },
        {
          title: "Salas Acogedoras",
          description:
            "Creamos espacios que combinan comodidad y estilo para tu bienestar diario, transformando salas en ambientes acogedores.",
          imageSrc: "https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?q=80&w=2074&auto=format&fit=crop",
          imageAlt: "Remodelación de Salas",
        },
      ],
      otherServicesTitle: "Servicios Adicionales",
      otherServicesList: [
        "Remodelación Completa de Casas",
        "Instalación de Pisos",
        "Pintura Interior y Exterior",
        "Carpintería Personalizada",
        "Instalación de Gabinetes",
      ],
    },
    sectionD: {
      aboutTitle: "Sobre REMODELING JT",
      aboutImage: {
        src: "https://images.unsplash.com/photo-1581858726788-75bc0f6a952d?q=80&w=2070&auto=format&fit=crop",
        alt: "REMODELING JT - Jean F Teran",
      },
      aboutText: [
        "En REMODELING JT (Modeling JT LLC), nos especializamos en la remodelación de casas, cocinas y más, ofreciendo soluciones personalizadas para cada cliente con un enfoque en la calidad y el detalle. Bajo la dirección del Gerente Jean F Teran, hemos transformado más de 150 hogares en espacios ideales.",
        "Transformando espacios, creando hogares - ese es nuestro compromiso. Ofrecemos diseños funcionales y elegantes, materiales de alta calidad, e instalación profesional garantizada. Cada proyecto es una oportunidad para crear espacios que combinan comodidad y estilo para tu bienestar diario.",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "REMODELING JT",
      businessName: "REMODELING JT",
      contact: {
        phone: "3124985712",
        phoneLabel: "+1 (312) 498-5712",
        email: "jeanteran95@gmail.com",
        website: "https://remodelingjtllc.com/",
        address: "220 Highpoint Dr Apt 103, Romeoville, IL 60446",
      },
      socialMedia: {},
    },
    sectionF: {
      address: "220 Highpoint Dr Apt 103, Romeoville, IL 60446",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3007.8!2d-88.0895!3d41.6477!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x880e4e8e8e8e8e8e%3A0x8e8e8e8e8e8e8e8e!2s220%20Highpoint%20Dr%20%23103%2C%20Romeoville%2C%20IL%2060446!5e0!3m2!1sen!2sus!4v1730400000000!5m2!1sen!2sus",
    },
  },
};

export default config;